export const FETCH_ALL = 'contacts/FETCH_ALL';
export const FETCH_ALL_SUCCESS = 'contacts/FETCH_ALL_SUCCESS';
export const FETCH_ALL_ERROR = 'contacts/FETCH_ALL_ERROR';

export const FETCH_BY_USER_ID = 'contacts/FETCH_BY_USER_ID';
export const FETCH_BY_USER_ID_SUCCESS = 'contacts/FETCH_BY_USER_ID_SUCCESS';
export const FETCH_BY_USER_ID_ERROR = 'contacts/FETCH_BY_USER_ID_ERROR';

export const FETCH_ALL_BY_SPACE_ID = 'contacts/FETCH_ALL_BY_SPACE_ID';
export const FETCH_ALL_BY_SPACE_ID_SUCCESS = 'contacts/FETCH_ALL_BY_SPACE_ID_SUCCESS';
export const FETCH_ALL_BY_SPACE_ID_ERROR = 'contacts/FETCH_ALL_BY_SPACE_ID_ERROR';

export const CREATE = 'contacts/CREATE';
export const CREATE_SUCCESS = 'contacts/CREATE_SUCCESS';
export const CREATE_ERROR = 'contacts/CREATE_ERROR';

export const DOWNLOAD_VCARD = 'contacts/DOWNLOAD_VCARD';
export const DOWNLOAD_VCARD_SUCCESS = 'contacts/DOWNLOAD_VCARD_SUCCESS';
export const DOWNLOAD_VCARD_ERROR = 'contacts/DOWNLOAD_VCARD_ERROR';

export const UPDATE = 'contacts/UPDATE';
export const UPDATE_SUCCESS = 'contacts/UPDATE_SUCCESS';
export const UPDATE_ERROR = 'contacts/UPDATE_ERROR';

export const DELETE = 'contacts/DELETE';
export const DELETE_SUCCESS = 'contacts/DELETE_SUCCESS';
export const DELETE_ERROR = 'contacts/DELETE_ERROR';

export const SET_ACTIVE_CONTACT_ID = 'contacts/SET_ACTIVE_CONTACT_ID';

export const FETCH_ME = 'contacts/FETCH_ME';
export const FETCH_ME_SUCCESS = 'contacts/FETCH_ME_SUCCESS';
export const FETCH_ME_ERROR = 'contacts/FETCH_ME_ERROR';

export const UPDATE_ME = 'contacts/UPDATE_ME';
export const UPDATE_ME_SUCCESS = 'contacts/UPDATE_ME_SUCCESS';
export const UPDATE_ME_ERROR = 'contacts/UPDATE_ME_ERROR';

export const IMPORT = 'contacts/IMPORT';
export const IMPORT_SUCCESS = 'contacts/IMPORT_SUCCESS';
export const IMPORT_ERROR = 'contacts/IMPORT_ERROR';
